// Traducciones en Español
export default {
  // General
  appName: 'TorneosPro',
  loading: 'Cargando...',
  save: 'Guardar',
  cancel: 'Cancelar',
  edit: 'Editar',
  delete: 'Eliminar',
  create: 'Crear',
  add: 'Añadir',
  new: 'Nuevo',
  search: 'Buscar',
  searchTeam: 'Buscar equipo...',
  searching: 'Buscando',
  noResultsFound: 'No se encontraron resultados',
  filter: 'Filtrar',
  all: 'Todos',
  active: 'Activo',
  inactive: 'Inactivo',
  yes: 'Sí',
  no: 'No',
  name: 'Nombre',
  description: 'Descripción',
  status: 'Estado',
  actions: 'Acciones',
  details: 'Detalles',
  back: 'Atrás',
  next: 'Siguiente',
  previous: 'Anterior',
  close: 'Cerrar',
  confirm: 'Confirmar',
  optional: 'Opcional',
  required: 'Obligatorio',
  language: 'Idioma',
  share: 'Compartir',
  copy: 'Copiar',
  copied: 'Copiado',
  linkCopied: 'Enlace copiado',

  // Errores y mensajes
  error: 'Error',
  success: 'Éxito',
  warning: 'Aviso',
  info: 'Información',
  errorLoading: 'Error al cargar los datos',
  errorSaving: 'Error al guardar',
  errorDeleting: 'Error al eliminar',
  savedSuccess: 'Guardado correctamente',
  deletedSuccess: 'Eliminado correctamente',
  createdSuccess: 'Creado correctamente',
  updatedSuccess: 'Actualizado correctamente',
  confirmDelete: '¿Estás seguro de que quieres eliminar este elemento?',
  confirmDeleteTournament: '¿Eliminar el torneo',
  deleteTournamentWarning: 'Se eliminarán TODOS los equipos, jugadores, partidos y eventos asociados. Esta acción no se puede deshacer.',
  tournamentDeletedCompletely: 'Torneo y todos sus datos eliminados correctamente',
  noResults: 'No se encontraron resultados',
  requiredFields: 'Por favor, completa todos los campos obligatorios',

  // Auth
  login: 'Iniciar sesión',
  logout: 'Cerrar sesión',
  loginWithGoogle: 'Iniciar sesión con Google',
  welcomeBack: 'Bienvenido de nuevo',
  accessDenied: 'Acceso denegado',
  notApproved: 'Tu cuenta aún no ha sido aprobada',
  contactAdmin: 'Contacta con el administrador',

  // Navegación
  dashboard: 'Panel',
  organizations: 'Organizaciones',
  tournaments: 'Torneos',
  teams: 'Equipos',
  players: 'Jugadores',
  matches: 'Partidos',
  forms: 'Inscripciones',
  users: 'Usuarios',
  system: 'Sistema',
  settings: 'Configuración',
  publicView: 'Ver público',
  adminPanel: 'Panel Admin',
  home: 'Inicio',
  welcome: 'Bienvenido',
  managePlayers: 'Gestión de jugadores',
  manageTournaments: 'Gestión de torneos',
  manageTeams: 'Gestión de equipos',
  manageOrganizations: 'Gestión de organizaciones',
  manageMatches: 'Gestión de partidos',
  manageUsers: 'Gestión de usuarios',
  allTournaments: 'Todos los torneos',
  allTeams: 'Todos los equipos',

  // Dashboard
  welcomeMessage: 'Bienvenido al panel de administración',
  quickStats: 'Estadísticas rápidas',
  recentActivity: 'Actividad reciente',
  recentResults: 'Últimos resultados',
  upcomingMatches: 'Próximos partidos',
  todayMatches: 'Partidos de hoy',

  // Organizaciones
  organization: 'Organización',
  newOrganization: 'Nueva organización',
  editOrganization: 'Editar Organización',
  noOrganizations: 'No hay organizaciones',
  createFirstOrg: 'Crea tu primera organización para empezar',
  orgNamePlaceholder: 'Nombre de la organización',
  orgDescPlaceholder: 'Descripción breve',
  allOrganizations: 'Todas las organizaciones',

  // Confirmaciones de generación
  generateCalendarMessage: '¿Generar calendario de partidos? Esto puede sobrescribir partidos existentes.',
  generateKnockoutMessage: '¿Generar eliminatorias con los equipos clasificados?',
  deleteEventConfirmMessage: '¿Eliminar este evento del partido?',

  // Torneos
  tournament: 'Torneo',
  newTournament: 'Nuevo torneo',
  editTournament: 'Editar Torneo',
  noTournaments: 'No hay torneos',
  createFirstTournament: 'Crea tu primer torneo',
  statusUpcoming: 'Próximamente',
  statusOngoing: 'En curso',
  statusFinished: 'Finalizado',
  tournamentName: 'Nombre del torneo',
  tournamentFormat: 'Formato',
  league: 'Liga',
  cup: 'Copa',
  groups: 'Grupos',
  startDate: 'Fecha de inicio',
  endDate: 'Fecha de fin',
  registrationOpen: 'Inscripción abierta',
  sport: 'Deporte',
  selectSport: 'Seleccionar deporte',
  selectOrganization: 'Seleccionar organización',
  selectTournament: 'Seleccionar torneo',
  season: 'Temporada',
  pointsWin: 'Puntos por victoria',
  pointsDraw: 'Puntos por empate',
  pointsLoss: 'Puntos por derrota',

  // Equipos
  team: 'Equipo',
  newTeam: 'Nuevo equipo',
  editTeam: 'Editar Equipo',
  noTeams: 'No hay equipos',
  createFirstTeam: 'Añade el primer equipo al torneo',
  teamName: 'Nombre del equipo',
  shortName: 'Nombre corto',
  teamColor: 'Color del equipo',
  logo: 'Escudo',
  group: 'Grupo',
  contact: 'Contacto',
  phone: 'Teléfono',

  // Jugadores
  player: 'Jugador',
  newPlayer: 'Nuevo jugador',
  editPlayer: 'Editar Jugador',
  noPlayers: 'No hay jugadores',
  createFirstPlayer: 'Añade el primer jugador',
  playerName: 'Nombre del jugador',
  number: 'Dorsal',
  position: 'Posición',
  selectTeam: 'Seleccionar equipo',
  goals: 'Goles',
  assists: 'Asistencias',
  yellowCards: 'Tarjetas amarillas',
  redCards: 'Tarjetas rojas',
  suspended: 'Sancionado',
  suspendedMatches: 'Partidos sanción',

  // Posiciones
  goalkeeper: 'Portero',
  defender: 'Defensa',
  midfielder: 'Centrocampista',
  forward: 'Delantero',

  // Partidos
  match: 'Partido',
  newMatch: 'Nuevo partido',
  editMatch: 'Editar Partido',
  noMatches: 'No hay partidos',
  createFirstMatch: 'Crea el primer partido',
  homeTeam: 'Equipo local',
  awayTeam: 'Equipo visitante',
  dateTime: 'Fecha y hora',
  location: 'Lugar',
  round: 'Jornada',
  referee: 'Árbitro',
  result: 'Resultado',
  enterResult: 'Introducir Resultado',
  scheduled: 'Programado',
  live: 'En juego',
  finished: 'Finalizado',
  postponed: 'Aplazado',
  cancelled: 'Cancelado',
  vs: 'vs',
  generateCalendar: 'Generar Calendario',
  clearCalendar: 'Borrar Calendario',

  // Tipos de resultado
  resultIn: 'Resultado en',
  regularTime: 'Tiempo regular',
  overtime: 'Prórroga',
  penalties: 'Penaltis',
  penaltiesResult: 'Resultado en penaltis',

  // Clasificación
  standings: 'Clasificación',
  played: 'Jugados',
  won: 'PG',
  drawn: 'PE',
  lost: 'PP',
  goalsFor: 'GF',
  goalsAgainst: 'GC',
  goalDifference: 'DG',
  points: 'Pts',

  // Usuarios
  user: 'Usuario',
  newUser: 'Nuevo usuario',
  editUser: 'Editar Usuario',
  noUsers: 'No hay usuarios',
  email: 'Email',
  role: 'Rol',
  admin: 'Administrador',
  editor: 'Editor',
  viewer: 'Visualizador',
  approved: 'Aprobado',
  pending: 'Pendiente',
  assignOrganizations: 'Asignar organizaciones',

  // Público
  selectSportTitle: 'Selecciona un deporte',
  availableTournaments: 'Torneos disponibles',
  noActiveTournaments: 'No hay torneos activos',
  viewTournament: 'Ver torneo',
  calendar: 'Calendario',
  results: 'Resultados',

  // Deportes
  football: 'Fútbol',
  basketball: 'Baloncesto',
  volleyball: 'Voleibol',
  tennis: 'Tenis',
  handball: 'Balonmano',
  hockey: 'Hockey',
  rugby: 'Rugby',
  baseball: 'Béisbol',
  futsal: 'Fútbol Sala',
  football7: 'Fútbol 7',
  football11: 'Fútbol 11',
  pelota: 'Pelota',
  beach: 'Fútbol Playa',
  beachVolley: 'Voley Playa',
  beachSoccer: 'Fútbol Playa',
  padel: 'Pádel',
  tableTennis: 'Tenis de Mesa',
  badminton: 'Bádminton',
  waterpolo: 'Waterpolo',
  fieldhockey: 'Hockey Hierba',
  americanFootball: 'Fútbol Americano',
  cricket: 'Cricket',
  rowing: 'Remo',
  swimming: 'Natación',
  cycling: 'Ciclismo',
  athletics: 'Atletismo',
  gymnastics: 'Gimnasia',
  boxing: 'Boxeo',
  wrestling: 'Lucha',
  judo: 'Judo',
  karate: 'Karate',
  taekwondo: 'Taekwondo',
  fencing: 'Esgrima',
  archery: 'Tiro con Arco',
  shooting: 'Tiro Olímpico',
  equestrian: 'Hípica',
  golf: 'Golf',
  sailing: 'Vela',
  canoeing: 'Piragüismo',
  surfing: 'Surf',
  skateboarding: 'Skateboard',
  climbing: 'Escalada',
  skiing: 'Esquí',
  icehockey: 'Hockey Hielo',
  figureskating: 'Patinaje Artístico',
  curling: 'Curling',
  bobsled: 'Bobsled',
  biathlon: 'Biatlón',
  esports: 'eSports',
  chess: 'Ajedrez',
  darts: 'Dardos',
  billiards: 'Billar',
  bowling: 'Bolos',
  pelotaVasca: 'Pelota Vasca',

  // Configuración de desempate
  tiebreaker: 'Desempate',
  tiebreakerCriteria: 'Criterios de desempate',
  headToHead: 'Enfrentamiento directo',
  goalDiff: 'Diferencia de goles',
  goalsScored: 'Goles a favor',
  awayGoals: 'Goles fuera',

  // Estadísticas
  stats: 'Estadísticas',
  totalGoals: 'Total de goles',
  avgGoals: 'Media de goles',
  cleanSheets: 'Porterías a cero',

  // Tiempo
  today: 'Hoy',
  tomorrow: 'Mañana',
  yesterday: 'Ayer',
  thisWeek: 'Esta semana',
  nextWeek: 'Próxima semana',

  // Acciones rápidas
  quickAdd: 'Añadir varios',
  quickAddTeams: 'Añadir varios equipos',
  quickAddPlayers: 'Añadir varios jugadores',
  teamsPlaceholder: 'Un equipo por línea...\n\nEjemplo:\nReal Madrid\nBarcelona\nAtlético de Madrid',
  playersPlaceholder: 'Un jugador por línea (nombre o nombre, dorsal)...\n\nEjemplo:\nMessi, 10\nRonaldo, 7\nBenzema',
  linesProcessed: 'líneas procesadas',
  teamsCreated: 'equipos creados',
  playersCreated: 'jugadores creados',

  // Calendario
  calendarSettings: 'Configurar Calendario',
  calendarFormat: 'Formato',
  roundRobin: 'Liga (todos contra todos)',
  knockout: 'Eliminatorias',
  singleRound: 'Solo ida',
  doubleRound: 'Ida y vuelta',
  groupsKnockout: 'Grupos + Eliminatorias',
  shuffleTeams: 'Sortear emparejamientos',
  thirdPlaceMatch: 'Partido por el tercer puesto',
  knockoutBracketInfo: 'Se generará un bracket para {teams} equipos',
  numberOfGroups: 'Número de grupos',
  qualifiedPerGroup: 'Clasificados por grupo',
  doubleRoundGroups: 'Doble vuelta en grupos',
  qualified: 'Clasificados',
  generateKnockout: 'Generar Eliminatorias',
  scheduleSettings: 'Configuración de fechas',
  knockoutMatchesGenerated: 'partidos de eliminatorias generados',
  confirmGenerateKnockout: '¿Generar partidos de eliminatorias con los equipos clasificados?',
  notEnoughQualified: 'No hay suficientes equipos clasificados',
  final: 'Final',
  semifinal: 'Semifinal',
  cuartos: 'Cuartos de Final',
  octavos: 'Octavos de Final',
  dieciseisavos: 'Dieciseisavos',
  tercer_puesto: 'Tercer Puesto',
  bracket: 'Eliminatorias',
  groupPhase: 'Fase de Grupos',
  knockoutPhase: 'Fase Eliminatoria',
  winner: 'Ganador',
  vsShort: 'vs',
  matchOrder: 'Orden de partidos',
  randomOrder: 'Aleatorio',
  registrationOrder: 'Por orden de inscripción',
  daysBetweenRounds: 'Días entre jornadas',
  defaultTime: 'Hora por defecto',
  defaultLocation: 'Lugar por defecto',
  deleteExisting: 'Eliminar partidos existentes',
  deleteExistingHint: 'Se eliminarán todos los partidos del torneo antes de generar los nuevos',
  generate: 'Generar',
  matchesGenerated: 'partidos generados',
  needTwoTeams: 'Necesitas al menos 2 equipos',
  selectTournamentFirst: 'Selecciona un torneo primero',
  selectTeamFirst: 'Selecciona un equipo primero',
  confirmGenerate: '¿Generar el calendario? Esta acción no se puede deshacer.',
  roundN: 'Jornada',

  // Público
  publicSubtitle: 'Gestión de torneos deportivos',
  chooseSport: 'Elige un deporte',
  activeSports: 'Deportes con torneos activos',
  allSports: 'Otros deportes',
  checkBackLater: 'Vuelve pronto para ver los torneos disponibles',
  tournamentsCount: 'torneos',
  noUpcomingMatches: 'No hay próximos partidos',
  noRecentResults: 'No hay resultados recientes',
  selectTournamentHint: 'Selecciona un torneo para ver más detalles',
  noDescription: 'Sin descripción',
  standingsTab: 'Clasificación',
  matchesTab: 'Partidos',
  scorers: 'Goleadores',
  teamsTab: 'Equipos',
  shareText: '¡Mira el torneo {name}!',
  noMatchesYet: 'Aún no hay partidos programados',
  noTeamsYet: 'Aún no hay equipos inscritos',
  roundLabel: 'Jornada',
  groupLabel: 'Grupo',

  // Goleadores y eventos
  scorer: 'Goleador',
  assistant: 'Asistencia de',
  minute: 'Minuto',
  ownGoal: 'En propia puerta',
  penalty: 'Penalti',
  noEvents: 'No hay eventos registrados',
  topScorers: 'Máximos goleadores',
  topAssisters: 'Máximos asistentes',

  // Traducciones adicionales
  activeTournaments: 'Torneos activos',
  addGoal: 'Añadir gol',
  addPlayersToTeam: 'Añadir jugadores al equipo',
  allowDraw: 'Permitir empate',
  allowDrawHint: 'Si está desactivado, los partidos deben tener ganador',
  approve: 'Aprobar',
  approvedSuccess: 'Usuario aprobado correctamente',
  authorizedOnly: 'Solo usuarios autorizados',
  awayGoalsHint: 'Goles como visitante en caso de empate',
  awayGoalsRule: 'Regla de goles visitante',
  cards: 'Tarjetas',
  color: 'Color',
  confirmDeleteMatch: '¿Eliminar este partido?',
  confirmDeleteOrg: '¿Eliminar esta organización?',
  confirmDeletePlayer: '¿Eliminar este jugador?',
  confirmDeleteTeam: '¿Eliminar este equipo?',
  confirmDeleteUser: '¿Eliminar este usuario?',
  continueWith: 'Continuar con',
  createFirstOrganization: 'Crea tu primera organización',
  createFirstUser: 'Crea el primer usuario',
  delegateName: 'Nombre del delegado',
  emailAndNameRequired: 'Email y nombre son obligatorios',
  emailExists: 'Este email ya está registrado',
  fillAllFields: 'Completa todos los campos obligatorios',
  fiveSets: 'Cinco sets',
  format: 'Formato',
  fourQuarters: 'Cuatro cuartos',
  fullName: 'Nombre completo',
  knockoutSettings: 'Configuración de eliminatorias',
  loginError: 'Error al iniciar sesión',
  lossInOvertime: 'Derrota en prórroga',
  lossInPenalties: 'Derrota en penaltis',
  matchDuration: 'Duración del partido',
  matchEvents: 'Eventos del partido',
  matchSettings: 'Configuración de partido',
  matchday: 'Ronda',
  minutes: 'minutos',
  nameAndTeamRequired: 'Nombre y equipo son obligatorios',
  nameRequired: 'El nombre es obligatorio',
  noAccount: '¿No tienes cuenta?',
  noCards: 'Sin tarjetas',
  noCardsYet: 'No hay tarjetas registradas',
  noGoalsYet: 'No hay goles registrados',
  noMatchesScheduled: 'No hay partidos programados',
  noPermissionSection: 'No tienes permiso para ver esta sección',
  noScorers: 'No hay goleadores',
  noTeamsInTournament: 'No hay equipos en este torneo',
  none: 'Ninguno',
  organizationName: 'Nombre de la organización',
  overtimeAvailable: 'Prórroga disponible',
  overtimeDuration: 'Duración de prórroga',
  overtimePenalties: 'Prórroga y penaltis',
  password: 'Contraseña',
  passwordRequired: 'La contraseña es obligatoria',
  passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
  passwordHint: 'El usuario usará esta contraseña para acceder',
  leaveEmptyToKeep: 'Dejar vacío para mantener',
  userCreatedSuccess: 'Usuario creado correctamente',
  accountActivated: 'Cuenta activada correctamente',
  penaltiesAvailable: 'Penaltis disponibles',
  pendingApproval: 'Pendiente de aprobación',
  pendingInvitations: 'Invitaciones pendientes',
  invited: 'Invitado',
  invitationCreated: 'Invitación creada correctamente',
  inviteUser: 'Invitar usuario',
  sendInvitation: 'Enviar invitación',
  inviteUserHint: 'El usuario podrá acceder cuando se registre con este email',
  optionalName: 'Nombre (opcional)',
  emailRequired: 'El email es obligatorio',
  waitingRegistration: 'Esperando registro',
  pendingRequests: 'Solicitudes pendientes',
  periods: 'Periodos',
  pivot: 'Pívot',
  reject: 'Rechazar',
  rejectedSuccess: 'Usuario rechazado',
  scoring: 'Puntuación',
  select: 'Seleccionar',
  selectTeamOrAddPlayers: 'Selecciona un equipo o añade jugadores',
  sessionStarted: 'Sesión iniciada',
  squad: 'Plantilla',
  statistics: 'Estadísticas',
  threePeriods: 'Tres periodos',
  tournamentActive: 'Torneo activo',
  tournamentConfig: 'Configuración del torneo',
  tournamentDescription: 'Descripción del torneo',
  twoLegs: 'Ida y vuelta',
  twoPeriods: 'Dos partes',
  universal: 'Universal',
  unspecified: 'Sin especificar',
  userActive: 'Usuario activo',
  userCanAccess: 'El usuario puede acceder',
  userNotFound: 'Usuario no encontrado',
  winInOvertime: 'Victoria en prórroga',
  winInPenalties: 'Victoria en penaltis',
  winger: 'Extremo',
  wrongPassword: 'Contraseña incorrecta',

  // Tarjetas
  yellowCard: 'Tarjeta amarilla',
  redCard: 'Tarjeta roja',
  secondYellow: 'Segunda amarilla',
  addCard: 'Añadir tarjeta',
  cardType: 'Tipo de tarjeta',
  cardsReceived: 'Tarjetas recibidas',
  suspendedPlayers: 'Jugadores sancionados',
  accumulatedCards: 'Tarjetas acumuladas',
  sanctionLimit: 'Límite de sanción',
  matchesSuspended: 'Partidos de sanción',

  // Logos de equipo (escudo). Los del torneo/org viven más abajo como uploadLogo/changeLogo.
  teamLogo: 'Escudo del equipo',
  uploadTeamLogo: 'Subir escudo',
  changeTeamLogo: 'Cambiar escudo',
  removeLogo: 'Quitar escudo',
  logoUploaded: 'Escudo subido correctamente',
  logoRemoved: 'Escudo eliminado',
  invalidImageFormat: 'Formato de imagen no válido',
  imageTooLarge: 'La imagen es demasiado grande (máx. 2MB)',

  // Public zone
  sports: 'Deportes',
  openRegistrations: 'Inscripciones abiertas',
  noOpenRegistrations: 'No hay inscripciones abiertas',
  signUp: 'Inscribirse',
  registrations: 'Inscripciones',
  groupPhaseLabel: 'Fase de grupos',
  knockoutPhaseLabel: 'Eliminatorias',
  mvpTitle: 'Jugador Más Valioso',
  mvpScoring: 'Puntuación MVP: Acierto = 3pts | Asistencia = 2pts | Amarilla = -1pt | Roja = -3pts',
  noMvpData: 'Aún no hay datos suficientes',
  noAssistsYetFull: 'Aún no hay asistencias registradas',
  assistsShort: 'asist.',

  // Registration form
  formNotFound: 'Formulario no encontrado',
  formLoadError: 'Error al cargar el formulario',
  teamNameRequired: 'El nombre del equipo es obligatorio',
  contactNameRequired: 'El nombre del contacto es obligatorio',
  addAtLeastOnePlayer: 'Añade al menos un jugador',
  checkCaptcha: 'Marca la casilla "No soy un robot"',
  submitError: 'Error al enviar la inscripción. Inténtalo de nuevo.',
  goHome: 'Ir al inicio',
  registrationsClosed: 'Inscripciones cerradas',
  registrationDeadlinePassed: 'El plazo de inscripción para este torneo ha terminado.',
  deadlineExpired: 'Plazo expirado',
  deadlineExpiredMsg: 'La fecha límite de inscripción ha pasado.',
  registrationSent: 'Inscripción enviada',
  registrationConfirmMsg: 'El organizador revisará tu inscripción y se pondrá en contacto contigo.',
  shareRegistration: 'Compartir inscripción',
  closingSoon: 'Cierra pronto',
  closingIn: 'Cierre de inscripciones en',
  days: 'días',
  hours: 'horas',
  min: 'min',
  sec: 'seg',
  registrationForm: 'Formulario de inscripción',
  teamNameLabel: 'Nombre del equipo',
  teamNamePlaceholder: 'Nombre de tu equipo',
  contactNameLabel: 'Nombre del delegado/contacto',
  contactNamePlaceholder: 'Tu nombre completo',
  // phone/playerName ya declarados arriba en la sección Equipos/Jugadores.
  emailLabel: 'Email',
  playersMax: 'Jugadores (máx. {max})',
  positionLabel: 'Posición',
  posGoalkeeper: 'Portero',
  posDefender: 'Cierre',
  posWinger: 'Ala',
  posPivot: 'Pívot',
  posUniversal: 'Universal',
  playersHint: 'Rellena solo los jugadores que tengas confirmados. Puedes dejar filas vacías.',
  commentsLabel: 'Comentarios / Observaciones',
  commentsPlaceholder: 'Cualquier información adicional...',
  sending: 'Enviando...',
  sendRegistration: 'Enviar inscripción',
  shareBtn: 'Compartir',
  // Public registration — campos jugador / mensajes / cabeceras tabla
  playerLastName: 'Apellidos',
  playerDni: 'DNI / Pasaporte',
  playerBirthDate: 'Fecha de nacimiento',
  playerBirthDateShort: 'F. nacimiento',
  playerNumber: 'Dorsal',
  playerSize: 'Talla',
  playerEmail: 'Email',
  playerPhone: 'Teléfono',
  playerN: 'JUGADOR',
  playersTitle: 'Jugadores',
  playersTitleMinMax: 'mín. {min}, máx. {max}',
  playersTitleMax: 'máx. {max}',
  phoneRequired: 'El teléfono es obligatorio',
  // emailRequired ya declarado arriba.
  minPlayersError: 'Debes inscribir al menos {min} jugadores. Has rellenado {filled}.',
  missingFieldOfPlayer: 'Falta {field} del jugador {n}',
  playerValidationPrefix: 'Jugador {n}',
  vName: 'el nombre',
  vLastName: 'los apellidos',
  vDni: 'el DNI/Pasaporte',
  vBirthDate: 'la fecha de nacimiento',
  vNumber: 'el dorsal',
  vPosition: 'la posición',
  vSize: 'la talla',
  vEmail: 'el email',
  vPhone: 'el teléfono',
  dniLetterError: 'La letra del DNI {value} no es correcta (debería ser {expected})',
  nieLetterError: 'La letra del NIE {value} no es correcta (debería ser {expected})',
  inscriptionsNotInPlan: 'Las inscripciones online no están disponibles para este torneo. Contacta directamente con la organización.',
  captchaServerFailed: 'Verificación de seguridad fallida. Marca el "No soy un robot" otra vez y reenvía.',
  deadlinePassedError: 'El plazo de inscripción ha terminado.',
  tooManyAttempts: 'Has enviado demasiadas inscripciones recientemente con este email. Inténtalo más tarde.',
  formNotFoundReload: 'El formulario ya no está disponible. Recarga la página.',
  submitErrorRetry: 'Marca el captcha de nuevo y reintenta.',
  waitlistTitle: 'Estás en lista de espera',
  waitlistMessage: 'Las plazas para "{title}" ya estaban completas, pero tu equipo "{team}" ha quedado en lista de espera. Te avisaremos si se libera alguna plaza.',
  registrationSentMessage: 'Tu equipo "{team}" se ha inscrito correctamente en "{title}".',
  backToTournaments: 'Volver a torneos',
  backShort: 'Volver',
  seatsFull: 'Plazas completas ({current}/{max})',
  seatsCounter: '{current} de {max} plazas — quedan {remaining}',
  waitlistNote: 'Si te inscribes ahora, quedarás en lista de espera.',
  whatsappShareText: '¡Nos hemos inscrito en {title}! 🏆\n\nInscríbete tú también:\n{url}',
  captchaLoadFailed: 'No se pudo cargar la verificación de seguridad (puede ser tu red o una extensión del navegador). Prueba a recargar la página o contacta directamente con la organización del torneo.',
  legalConsentText: 'Al enviar este formulario aceptas que los datos proporcionados (incluido el nombre del equipo) serán revisados por la organización del torneo y podrán ser publicados en la web. TorneosPro actúa únicamente como plataforma tecnológica y no se hace responsable del contenido introducido por los usuarios ni de las decisiones de la organización. Consulta nuestra',
  privacyPolicyLink: 'política de privacidad',
  phonePlaceholder: '600 000 000',
  emailPlaceholderExample: 'tu@email.com',

  // Legal
  privacyPolicy: 'Política de Privacidad',
  legalNotice: 'Aviso Legal',
  cookiePolicy: 'Política de Cookies',
  privacy: 'Privacidad',
  legalShort: 'Aviso legal',
  cookies: 'Cookies',

  // Admin - Tournaments
  onlyImagesAllowed: 'Solo se permiten imágenes',
  imageMaxSize500: 'La imagen no puede superar 500KB',
  tournamentLogo: 'Logo del torneo',
  changeLogo: 'Cambiar logo',
  uploadLogo: 'Subir logo',
  removeLogoBtn: 'Quitar logo',
  tiebreakerTab: 'Desempate',
  visibilityTab: 'Visibilidad',
  tiebreakerHint: 'Orden de criterios cuando dos equipos están empatados a puntos. El primero tiene prioridad.',
  tbPoints: 'Puntos',
  tbHeadToHead: 'Enfrentamiento directo',
  tbGoalDifference: 'Diferencia de goles',
  tbGoalsFor: 'Goles a favor',
  tbGoalsAgainst: 'Goles en contra',
  tbWins: 'Victorias',
  tbLosses: 'Derrotas (menos = mejor)',
  tbPointsDifference: 'Diferencia de puntos',
  tbPointsFor: 'Puntos a favor',
  tbSetsDifference: 'Diferencia de sets',
  tbSetsFor: 'Sets ganados',
  tbRandom: 'Sorteo aleatorio',
  tbLossesShort: 'Derrotas',
  tbPointsDifferenceShort: 'Dif. puntos',
  tbSetsDifferenceShort: 'Dif. sets',
  tbRandomShort: 'Sorteo',
  addCriterion: 'Añadir criterio:',
  visibilityHint: 'Elige qué secciones se muestran en la zona pública del torneo.',
  visTabStandings: 'Clasificación',
  visTabGroups: 'Grupos',
  visTabBracket: 'Bracket / Eliminatorias',
  visTabMatches: 'Partidos',
  visTabScorers: 'Máximos goleadores',
  visTabAssists: 'Asistencias',
  visTabMvp: 'MVP',
  visTabFairplay: 'Fair Play',
  visTabTeams: 'Equipos',
  notAvailableFormat: '(no aplica a este formato)',

  // Admin - Teams
  selectTournamentFirstMsg: 'Selecciona un torneo primero',
  needTwoTeamsMsg: 'Necesitas al menos 2 equipos',
  maxEightGroups: 'Máximo 8 grupos',
  groupsSavedOk: 'Grupos guardados correctamente',
  selectTargetTournament: 'Selecciona el torneo destino',
  selectAtLeastOneTeam: 'Selecciona al menos un equipo',
  teamsImportedWithPlayers: 'equipos importados con sus jugadores',
  importPartialPlayersWarning: 'Atención: algunos jugadores no se han podido copiar. Los equipos sí se importaron.',
  importNoPlayersFound: 'Los equipos del torneo origen no tenían jugadores que copiar.',
  importBtn: 'Importar',
  groupsBtn: 'Grupos',
  groupsLabel2: 'Grupos: ',
  deleteGroupTitle: 'Eliminar grupo',
  removeFromGroupTitle: 'Quitar del grupo',
  importTeamsFromTournament: 'Importar equipos de otro torneo',
  teamsLowercase: 'equipos',
  deselectAll: 'Deseleccionar todos',
  selectAll: 'Seleccionar todos',

  // Admin - Players
  bulkPlayersPlaceholder: 'Juan García, 7, Portero\nPedro López, 10, Ala\nCarlos Ruiz, 5\nMiguel Torres',
  bulkPlayersFormat: 'Formato: Nombre, Dorsal, Posición (dorsal y posición opcionales)',

  // Admin - Matches
  generateKnockoutTitle: 'Generar eliminatorias',
  generateKnockoutMsg: 'Se generarán eliminatorias con',
  qualifiedTeamsText: 'equipos clasificados',
  perGroupText: 'por grupo',
  generateBtn: 'Generar',

  // Admin - Users / Mesa
  pinCodeLabel: 'Código PIN',
  pinCopied: 'PIN copiado',
  regeneratePin: 'Regenerar',
  mesaUrlHint: 'La mesa entra en esa URL e introduce este código PIN.',
  mesaWhatsappPrefix: 'Mesa de partido - ',
  mesaWhatsappEnter: 'Entra en: torneospro.com/#/mesa',
  mesaWhatsappPin: 'Código PIN: ',
  copyWhatsappData: 'Copiar datos para WhatsApp',

  // Admin - Forms
  deleteFormTitle: 'Eliminar formulario',
  createTeamFromRegistration: 'Crear equipo desde inscripción',
  deleteRegistrationTitle: 'Eliminar inscripción',
  registrationDeleted: 'Inscripción eliminada',
  changeImage: 'Cambiar imagen',
  uploadImage: 'Subir imagen',
  deleteBtn: 'Eliminar',
  registrationReceivedAt: 'Inscripción recibida: ',

  // Admin - Settings
  configSaved: 'Configuración guardada',
  configTitle: 'Configuración',
  configSubtitle: 'Ajustes generales de la plataforma',
  visibleSportsTitle: 'Deportes visibles en la home pública',
  visibleSportsHint: 'Selecciona qué deportes se muestran en la página principal pública. Los deportes no seleccionados no aparecerán aunque tengan torneos.',

  // Admin - System
  repairProblem: 'Reparar problema',
  deleteOrphanEvent: '¿Eliminar este evento huérfano?',
  deleteProblemDoc: '¿Eliminar el documento con problema de',
  repairAll: 'Reparar todo',
  willDeleteDocs: 'Se eliminarán',
  docsWithProblems: 'documentos con problemas. ¿Continuar?',
  backupDownloaded: 'Backup descargado',
  resetTournamentTitle: 'Resetear torneo',
  resetTournamentMsg: 'Se borrarán TODOS los resultados, eventos y partidos de',
  resetTournamentKeep: 'Los equipos y jugadores se mantienen. ¿Continuar?',
  maintenanceOn: 'Modo mantenimiento activado',
  maintenanceOff: 'Modo mantenimiento desactivado',
  systemSubtitle: 'Herramientas de mantenimiento y diagnóstico',
  systemTabHealth: 'Salud',
  systemTabErrors: 'Errores',
  systemTabBackup: 'Backup',
  systemTabTools: 'Herramientas',
  systemTabMaintenance: 'Mantenimiento',
  scanning: 'Escaneando...',
  scan: 'Escanear',
  pressScanHint: 'Pulsa "Escanear" para revisar la base de datos',
  noErrorsPending: 'No hay errores sin resolver',
  backupHint: 'Descarga una copia completa de todos los datos de la plataforma en formato JSON.',
  exporting: 'Exportando...',
  downloadFullBackup: 'Descargar backup completo',
  backupIncludes: 'Incluye: torneos, equipos, jugadores, partidos, eventos, organizaciones, usuarios, formularios e inscripciones.',
  resetTournamentCard: 'Resetear torneo',
  resetTournamentCardDesc: 'Borra resultados, partidos y eventos. Mantiene equipos y jugadores.',
  resetBtn: 'Resetear',
  duplicateTournamentCard: 'Duplicar torneo',
  duplicateTournamentCardDesc: 'Copia torneo completo con equipos y jugadores para nueva temporada.',
  duplicateBtn: 'Duplicar',
  maintenanceMode: 'Modo mantenimiento',
  maintenanceHint: 'Cuando está activado, los usuarios públicos ven un mensaje de "En mantenimiento" en vez de la app.',
  maintenanceActivated: 'ACTIVADO',
  maintenanceDeactivated: 'DESACTIVADO',
  disableMaintenance: 'Desactivar mantenimiento',
  enableMaintenance: 'Activar mantenimiento',
  resetModalHint: 'Se borrarán todos los partidos, resultados y eventos. Los equipos y jugadores se mantienen con estadísticas a 0.',
  copySuffix: '(copia)',
  duplicateHint: 'Se copiarán equipos y jugadores. Estadísticas a 0, sin partidos.',

  // Admin - Organizations
  cityTown: 'Ciudad / Pueblo',

  // Admin - Dashboard
  viewTournamentsBtn: 'Ver Torneos',
  viewMatchesBtn: 'Ver Partidos',

  // ============================================================
  // Zona web pública (marketing)
  // ============================================================

  // Web - Layout (navbar, footer)
  webDefaultDescription: 'Gestiona torneos de 12 deportes: fútbol, fútbol sala, baloncesto, voleibol, tenis, pádel, balonmano, hockey, rugby, pelota y más. Inscripciones online, calendarios, clasificaciones en tiempo real. Para pueblos, clubes y ayuntamientos.',
  webDefaultTitleSuffix: 'Gestión de torneos deportivos',
  webNavProduct: 'Producto',
  webNavHome: 'Inicio',
  webNavPricing: 'Precios',
  webNavGallery: 'Galería',
  webNavContact: 'Contacto',
  webNavFeatures: 'Características',
  webNavHowItWorks: 'Cómo funciona',
  webNavForOrgs: 'Para quién es',
  webNavFAQShort: 'FAQ',
  webNavFAQLong: 'Preguntas frecuentes',
  webNavSubFeaturesDesc: 'Todo lo que puedes hacer',
  webNavSubHowItWorksDesc: 'Pasos para empezar',
  webNavSubForOrgsDesc: 'Pueblos, clubes, ayuntamientos',
  webNavSubFAQDesc: 'Dudas habituales',
  webNavViewTournaments: 'Ver torneos',
  webNavLoginToPanel: 'Entrar al panel',
  webMenuAria: 'Menú',
  webFooterTagline: 'La plataforma para gestionar torneos deportivos en pueblos, clubes y ayuntamientos.',
  webFooterColProduct: 'Producto',
  webFooterColResources: 'Recursos',
  webFooterColLegal: 'Legal',
  webFooterLinkLiveTournaments: 'Torneos en directo',
  webFooterLinkPrivacy: 'Privacidad',
  webFooterLinkTerms: 'Aviso legal',
  webFooterLinkCookies: 'Cookies',
  webFooterMadeIn: 'Hecho en España',

  // Web - Home
  webHomeTitle: 'Organiza torneos como un profesional',
  webHomeDescription: 'Gestiona torneos de 12 deportes: fútbol, fútbol sala, baloncesto, voleibol, tenis, pádel, balonmano, hockey, rugby, pelota y más. Inscripciones online, calendarios automáticos, clasificaciones en directo. Para pueblos, clubes y ayuntamientos.',
  webHomeBadge: 'Hecho en España · 12 deportes · En español',
  webHomeHeroLine1: 'Organiza torneos',
  webHomeHeroLine2: 'como un profesional',
  webHomeHeroSubtitle: 'Equipos, jugadores, calendarios, eliminatorias, inscripciones online y resultados en tiempo real. Para pueblos, clubes y ayuntamientos.',
  webHomeHeroCtaPricing: 'Ver precios',
  webHomeHeroCtaLive: 'Ver torneos en directo',
  webHomeHeroDisclaimer: 'Pago único + pack de horas anual · Sin suscripciones obligatorias',
  webHomeSectionsTitle1: 'Todo lo que necesitas,',
  webHomeSectionsTitle2: 'en un sitio',
  webHomeCardFeaturesTitle: 'Características',
  webHomeCardFeaturesDesc: 'Todo lo que puedes hacer con TorneosPro',
  webHomeCardHowItWorksTitle: 'Cómo funciona',
  webHomeCardHowItWorksDesc: '3 pasos sencillos para empezar',
  webHomeCardForOrgsTitle: 'Para quién es',
  webHomeCardForOrgsDesc: 'Pueblos, clubes y ayuntamientos',
  webHomeCardPricingTitle: 'Precios',
  webHomeCardPricingDesc: 'Puesta en marcha única + pack de horas anual',
  webHomeCardGalleryTitle: 'Galería',
  webHomeCardGalleryDesc: 'Fotos de torneos reales',
  webHomeCardFAQTitle: 'Preguntas frecuentes',
  webHomeCardFAQDesc: 'Las dudas más comunes',
  webHomeCardSeeMore: 'Ver más',
  webHomeExcelTitle1: 'Adiós al',
  webHomeExcelTitle2: 'Excel',
  webHomeExcelTitle3: 'hola a',
  webHomeExcelBadColumnTitle: 'Excel / WhatsApp / papel',
  webHomeExcelBad1: 'Apuntar resultados a mano',
  webHomeExcelBad2: 'Calcular clasificaciones manualmente',
  webHomeExcelBad3: 'Pelearte con fórmulas para los desempates',
  webHomeExcelBad4: 'Mensajes infinitos para cada cambio de hora',
  webHomeExcelBad5: 'Sin estadísticas de jugadores',
  webHomeExcelBad6: 'Sin inscripciones online',
  webHomeExcelGoodColumnTitle: 'Con TorneosPro',
  webHomeExcelGood1: 'Resultados en tiempo real desde el polideportivo',
  webHomeExcelGood2: 'Clasificación automática con tiebreakers configurables',
  webHomeExcelGood3: 'Eliminatorias generadas con un click',
  webHomeExcelGood4: 'Inscripciones públicas con QR y countdown',
  webHomeExcelGood5: 'Estadísticas individuales: goleadores, MVP, fair play',
  webHomeExcelGood6: 'PDF y Excel exportables al momento',
  webHomeSportsTitle1: 'Cualquier deporte,',
  webHomeSportsTitle2: 'hecho a tu medida',
  webHomeSportsIntro1: 'De serie ya tenemos',
  webHomeSportsIntro2: '12 deportes',
  webHomeSportsIntro3: 'configurados con su terminología, posiciones y formato propios. ¿Necesitas otro? Lo añadimos sin coste extra para tu organización.',
  webHomeSportFutsal: 'Fútbol sala',
  webHomeSportFootball7: 'Fútbol 7',
  webHomeSportFootball11: 'Fútbol 11',
  webHomeSportBasketball: 'Baloncesto',
  webHomeSportVolleyball: 'Voleibol',
  webHomeSportHandball: 'Balonmano',
  webHomeSportPadel: 'Pádel',
  webHomeSportTennis: 'Tenis',
  webHomeSportPelota: 'Pelota',
  webHomeSportRugby: 'Rugby',
  webHomeSportHockey: 'Hockey',
  webHomeSportBeachSoccer: 'Fútbol playa',
  webHomeSportYours: 'El tuyo',
  webHomeSportNotListedPre: '¿Tu deporte no está?',
  webHomeSportNotListedAsk: 'Pídelo',
  webHomeSportNotListedPost: 'y lo añadimos.',
  webHomeFinalTitle: '¿Hablamos de tu torneo?',
  webHomeFinalSubtitle: 'Cuéntanos qué quieres organizar y te preparamos un presupuesto a medida en menos de 24h laborables.',
  webHomeFinalCtaContact: 'Contactar',
  // Hero — precio orientativo
  webHomeHeroPriceHint: 'Presupuesto a medida · Sin compromiso',
  // Social proof
  webHomeProofBadge: 'EN PRODUCCIÓN',
  webHomeProofTitle: 'Hecho con torneos reales, no con maquetas',
  webHomeProofCaseLabel: 'CASO REAL',
  webHomeProofCaseTitle: 'Torneo de verano de Zarautz · Fútbol sala',
  webHomeProofCaseDesc: '3 años gestionando el torneo de verano de fútbol sala de Zarautz, con hasta 32 equipos y distintos formatos de liga (grupos + eliminatorias, doble vuelta, mixtos…). Resultados en directo desde el polideportivo y clasificación pública compartida por WhatsApp.',
  webHomeProofStatYears: 'Años',
  webHomeProofStatTeams: 'Equipos máx.',
  webHomeProofStatLive: 'En directo',
  webHomeProofSupportTitle: 'Soporte cercano y en tu idioma',
  webHomeProofSupportDesc: 'Te atendemos en español, euskera o inglés. Sin chatbots y sin tickets que tardan días: contestamos personalmente.',
  webHomeProofPaymentTitle: 'Pago único, sin sorpresas',
  webHomeProofPaymentDesc: 'Puesta en marcha pagada una vez + un pack de horas que decides tú. Sin suscripciones recurrentes que te ahogan al año.',
  // Screenshots
  webHomeScreensTitle1: 'Así se ve',
  webHomeScreensTitle2: 'TorneosPro',
  webHomeScreensSubtitle: 'Diseñado para verse bien en el polideportivo, en la oficina del ayuntamiento y en el móvil del padre que sigue a su hijo.',
  webHomeScreen1Label: 'Panel de administración',
  webHomeScreen1Desc: 'Crea torneos, equipos y jugadores en minutos.',
  webHomeScreen2Label: 'Mesa de partido',
  webHomeScreen2Desc: 'Cada mesa de partido entra con su código y ve solo sus partidos asignados.',
  webHomeScreen3Label: 'Página pública',
  webHomeScreen3Desc: 'Multi-deporte, con inscripciones abiertas y compartible por QR.',
  webHomeScreen4Label: 'Eliminatorias visuales',
  webHomeScreen4Desc: 'Bracket automático con stats, patrocinadores y máximos goleadores.',
  webHomeScreen5Label: 'Resultados en directo',
  webHomeScreen5Desc: 'Marcador, asistencia, goles y tarjetas desde la mesa de partido.',

  // Web - Features
  webFeaturesTitle: 'Características',
  webFeaturesDescription: 'Todas las funcionalidades de TorneosPro: torneos ilimitados, equipos y jugadores, calendario automático, clasificación en directo, eliminatorias, inscripciones online, mesa de partido, estadísticas, exportar PDF/Excel y más.',
  webFeaturesBadge: 'CARACTERÍSTICAS',
  webFeaturesHeroTitle1: 'Todo lo que',
  webFeaturesHeroTitle2: 'puedes hacer',
  webFeaturesHeroSubtitle: '12 funcionalidades clave que reemplazan Excel, WhatsApp y un cajón lleno de papeles.',
  webFeaturesItem1Title: 'Torneos ilimitados',
  webFeaturesItem1Desc: 'Crea tantos torneos como quieras: ligas, eliminatorias, formatos mixtos. Cada uno con su deporte, calendario y configuración.',
  webFeaturesItem2Title: 'Equipos y jugadores',
  webFeaturesItem2Desc: 'Gestión completa de equipos con escudo, color, contacto. Plantilla de jugadores con dorsal, posición y estadísticas individuales.',
  webFeaturesItem3Title: 'Calendario automático',
  webFeaturesItem3Desc: 'Genera calendarios en segundos: introduces fechas, horarios y campos disponibles. La app reparte los partidos por jornadas.',
  webFeaturesItem4Title: 'Clasificación en directo',
  webFeaturesItem4Desc: 'Cada gol que se mete actualiza la tabla. Tiebreakers configurables: puntos, goles, enfrentamientos directos, fair play.',
  webFeaturesItem5Title: 'Bracket eliminatorio',
  webFeaturesItem5Desc: 'Genera eliminatorias automáticamente desde la fase de grupos. Soporta prórroga, penaltis y avance automático del ganador.',
  webFeaturesItem6Title: 'Inscripciones online',
  webFeaturesItem6Desc: 'Formularios públicos con countdown, QR descargable, lista de espera automática y reCAPTCHA contra bots.',
  webFeaturesItem7Title: 'Mesa de partido',
  webFeaturesItem7Desc: 'Acceso con PIN para que en el polideportivo metan resultados, asistencia, goles y tarjetas en directo.',
  webFeaturesItem8Title: 'Estadísticas detalladas',
  webFeaturesItem8Desc: 'Ranking de goleadores, asistentes, MVP, fair play. Comparativas por equipo y jornada.',
  webFeaturesItem9Title: 'Exportar a PDF y Excel',
  webFeaturesItem9Desc: 'Genera al momento clasificación, calendario, fichas de equipos, plantillas con jugadores. Excel multi-hoja completo.',
  webFeaturesItem10Title: '100% móvil',
  webFeaturesItem10Desc: 'Funciona perfecto en móvil, tablet y ordenador. Se puede instalar en el móvil como una app más. Los avisos automáticos a los seguidores del torneo están disponibles en el plan Plus o superior.',
  webFeaturesItem11Title: 'Multi-idioma',
  webFeaturesItem11Desc: 'Español, euskera e inglés. Cada visitante ve la app en su idioma con un click.',
  webFeaturesItem12Title: 'Visibilidad online',
  webFeaturesItem12Desc: 'Cada torneo tiene su URL pública en torneospro.com. Compártelo por WhatsApp, redes sociales o QR.',
  webFeaturesCtaTitle: '¿Te encajan?',
  webFeaturesCtaPricing: 'Ver precios',
  webFeaturesCtaHowItWorks: 'Cómo funciona',

  // Web - HowItWorks
  webHowTitle: 'Cómo funciona',
  webHowDescription: '3 pasos para tener tu primer torneo en marcha en menos de una semana: pídenos presupuesto, te configuramos todo y a jugar. Sin compromiso.',
  webHowBadge: 'CÓMO FUNCIONA',
  webHowHeroTitle1: '3 pasos',
  webHowHeroTitle2: 'para empezar',
  webHowHeroSubtitle: 'En menos de una semana puedes tener tu primer torneo en marcha.',
  webHowStep1Title: 'Pídenos presupuesto',
  webHowStep1Desc: 'Cuéntanos qué quieres organizar (un torneo de fiestas, una liga municipal…) y te preparamos un presupuesto a medida en menos de 24h laborables. Sin compromiso.',
  webHowStep2Title: 'Te configuramos todo',
  webHowStep2Desc: 'Una vez firmado, damos de alta tu organización con tu logo y datos. Hacemos 1-2 videollamadas de formación contigo y los delegados. Configuramos tu primer torneo a tu lado.',
  webHowStep3Title: '¡A jugar!',
  webHowStep3Desc: 'Comparte la URL pública del torneo o el QR de inscripción. Las mesas meten resultados desde el polideportivo. Tú ves todo en tiempo real desde tu admin.',
  webHowCtaTitle: '¿Empezamos?',
  webHowCtaSubtitle: 'Pídenos presupuesto sin compromiso y te respondemos en menos de 24h laborables.',
  webHowCtaRequest: 'Solicitar presupuesto',
  webHowCtaPricing: 'Ver precios',

  // Web - ForOrgs
  webOrgsTitle: 'Para quién es',
  webOrgsDescription: 'TorneosPro está pensado para quien organiza torneos amateur: fiestas patronales, ayuntamientos, empresas, colegios, clubes deportivos, asociaciones y peñas.',
  webOrgsBadge: 'PARA QUIÉN',
  webOrgsHeroTitle1: '¿Te ves',
  webOrgsHeroTitle2: 'en alguno?',
  webOrgsHeroSubtitle: 'TorneosPro está pensado para quien organiza torneos amateur en pueblos, clubes o ayuntamientos.',
  webOrgsCase1Title: 'Fiestas patronales',
  webOrgsCase1Desc: 'Junta de fiestas de un pueblo de 1.000-5.000 habitantes que monta torneo de fútbol sala anual. Inscripciones por QR pegado en bares.',
  webOrgsCase2Title: 'Ayuntamientos',
  webOrgsCase2Desc: 'Liga municipal continua con varios deportes en paralelo durante todo el curso. Mesa de partido en cada polideportivo.',
  webOrgsCase3Title: 'Empresas',
  webOrgsCase3Desc: 'Torneo de empresa o intercompañías en fin de semana. Inscripción cerrada por email con plazas limitadas.',
  webOrgsCase4Title: 'Colegios e institutos',
  webOrgsCase4Desc: 'Liga interclases o competición escolar. Plantillas con jugadores menores de edad, datos protegidos.',
  webOrgsCase5Title: 'Clubes deportivos',
  webOrgsCase5Desc: 'Club federado con varias categorías y secciones. Equipos cadete, juvenil, sénior, veteranos.',
  webOrgsCase6Title: 'Asociaciones y peñas',
  webOrgsCase6Desc: 'Peña, AMPA, asociación cultural que organiza torneo amateur una vez al año en fechas señaladas.',
  webOrgsCtaTitle: '¿No estás seguro si encajas?',
  webOrgsCtaSubtitle: 'Cuéntanos tu caso y te decimos sin compromiso si TorneosPro te encaja o no.',
  webOrgsCtaButton: 'Solicitar presupuesto',

  // Web - FAQ
  webFAQTitle: 'Preguntas frecuentes',
  webFAQDescription: 'Resolvemos las dudas más habituales sobre TorneosPro: precios, instalación, gestión multi-torneo, soporte, datos, mesa de partido y mucho más.',
  webFAQBadge: 'FAQ',
  webFAQHeroTitle1: 'Preguntas',
  webFAQHeroTitle2: 'frecuentes',
  webFAQQ1: '¿Cuánto cuesta?',
  webFAQA1: 'Depende del tamaño de tu organización. Pagas una puesta en marcha inicial y eliges un pack de horas anual a tu medida. No hay suscripciones obligatorias. Cuéntanos qué quieres organizar y te preparamos un presupuesto en menos de 24h laborables.',
  webFAQQ2: '¿Necesito instalar algo?',
  webFAQA2: 'No. Funciona desde cualquier navegador (Chrome, Safari, Firefox) en ordenador, móvil o tablet. Si quieres, puedes añadirla al móvil como acceso directo igual que cualquier otra app.',
  webFAQQ3: '¿Los jugadores necesitan cuenta?',
  webFAQA3: 'No. Solo tú como organizador. Los jugadores y la afición acceden al torneo con un enlace público, sin registrarse.',
  webFAQQ4: '¿Puedo gestionar varios torneos a la vez?',
  webFAQA4: 'Sí, tantos como quieras. Cada uno con su deporte, formato, equipos y configuración independiente.',
  webFAQQ5: '¿Qué pasa con mis datos?',
  webFAQA5: 'Se guardan seguros en Firebase (Google Cloud) con reglas de acceso estrictas. Puedes descargar un backup completo cuando quieras.',
  webFAQQ6: '¿Hay soporte técnico?',
  webFAQA6: 'Sí. Puedes contactarnos por email a info@torneospro.com y respondemos en menos de 24h laborables. Los packs de horas incluyen soporte por WhatsApp/email.',
  webFAQQ7: '¿Aceptáis pago a 30 o 60 días?',
  webFAQA7: 'Sí, especialmente para ayuntamientos y entidades públicas con presupuesto. Te facilitamos toda la documentación administrativa que necesites.',
  webFAQQ8: '¿Puedo cambiar el formato del torneo después de empezar?',
  webFAQA8: 'Mejor no. Si cambias de Liga a Eliminatoria con partidos ya jugados, las clasificaciones se rompen. Si necesitas cambiar, exporta primero los datos.',
  webFAQQ9: '¿Puedo descargar los datos de mi torneo?',
  webFAQA9: 'Sí, en cada torneo botón "Exportar" → genera PDF (clasificación, goleadores, calendario, equipos) y Excel completo con todas las hojas.',
  webFAQQ10: '¿Cómo funciona la mesa de partido?',
  webFAQA10: 'Es un panel simplificado al que se accede desde torneospro.com/mesa con un PIN de 6 dígitos. La persona ve solo los partidos asignados y mete asistencia, goles y tarjetas en directo.',
  webFAQQ11: '¿Tenéis app nativa?',
  webFAQA11: 'No hace falta. La web se instala en el móvil como una app más. En iPhone se añade desde Safari → Compartir → Añadir a pantalla de inicio. En Android Chrome la ofrece automáticamente.',
  webFAQQ12: '¿Recibiré notificaciones cuando los equipos se inscriban?',
  webFAQA12: 'Estamos terminando ese módulo. De momento recibes el aviso al entrar al admin con el contador de pendientes.',
  webFAQCtaTitle: '¿No está tu duda?',
  webFAQCtaButton: 'Pregúntanos directamente',

  // Web - Contact
  webContactTitle: 'Contacto',
  webContactDescription: 'Cuéntanos qué quieres organizar y te preparamos un presupuesto a medida en menos de 24h laborables. Sin compromiso. info@torneospro.com',
  webContactBadge: 'CONTACTO',
  webContactHeroTitle1: 'Hablemos',
  webContactHeroTitle2: 'de tu torneo',
  webContactHeroSubtitle: 'Cuéntanos qué quieres organizar y te preparamos un presupuesto a medida en menos de 24h laborables.',
  webContactHoursLabel: 'Horario:',
  webContactHoursText: 'respondemos de lunes a viernes en menos de 24h laborables. Fines de semana y festivos puede tardar más.',

  // Web - 404
  web404Title: 'Página no encontrada',
  web404Description: 'La página que buscas no existe o ha sido movida.',
  web404HeadlinePart1: 'Esta página se ha',
  web404HeadlinePart2: 'salido del campo',
  web404Body: 'La página que buscas no existe, ha sido movida o el enlace está mal escrito. No te preocupes, te llevamos de vuelta al inicio.',
  web404CtaHome: 'Ir al inicio',
  web404CtaTournaments: 'Ver torneos',
  web404SuggestionsTitle: '¿Buscabas alguna de estas páginas?',
  web404SuggestPricing: 'Precios',
  web404SuggestFeatures: 'Características',
  web404SuggestGallery: 'Galería',
  web404SuggestFAQ: 'FAQ',
  web404SuggestContact: 'Contacto',

  // Galería pública
  galleryBadge: 'GALERÍA',
  galleryHeroTitle1: 'Los',
  galleryHeroTitleHighlight: 'mejores momentos',
  galleryHeroTitle2: 'de los torneos',
  galleryDescription: 'Fotos de torneos reales gestionados con TorneosPro: fiestas patronales, ligas municipales, torneos de empresa y más.',
  gallerySearchPlaceholder: 'Buscar álbum por torneo o deporte...',
  galleryEmptyTitle: 'Aún no hay fotos',
  galleryEmptyBody: 'Pronto subiremos los mejores momentos de los torneos.',
  galleryFeatured: 'Destacadas',
  galleryAlbumsTitle: 'Álbumes por torneo',
  galleryResultsCount: 'Resultados',
  galleryRotating: 'Rotando cada 5s',
  galleryAlbumsTotal: 'álbumes en total',
  galleryNoMatch: 'No hay álbumes que coincidan con',
  galleryPhotos: 'fotos',
  gallerySport: 'Deporte',

  // Página pública de precios
  pricingBadgePreLaunch: 'PRE-LANZAMIENTO',
  pricingBadgeQuote: 'Solicitud de presupuesto',
  pricingBadgeSuccess: 'Solicitud recibida',
  pricingRequestQuote: 'Solicitar presupuesto',
  pricingContactUs: 'Escríbenos',
  pricingBuy: 'Comprar plan',
  pricingSelected: 'Plan seleccionado',
  pricingIncluded: 'Incluye:',
  pricingNotIncluded: 'No incluido',
  pricingLimits: 'Límites',
  pricingUseCase: 'Ideal para:',
  pricingCta: 'Elegir plan',
  pricingCtaChosen: 'Plan elegido',
  pricingQuoteThanks: 'Solicitud recibida. Te contactaremos pronto.',
  pricingQuoteError: 'No se pudo enviar la solicitud'
};
